import React from 'react'
import utils from './utils'
import { images } from '../../../../services/assets.services'

function getLevelLayout(gameContainerWidth, gameContainerHeight, settings, quantities, answer, answerNumber = 1, previousAnswer = null) {

    const operation = settings.operation
    const firstValue = quantities.value_1
    const secondValue = quantities.value_2

    let scale = 0
    let gridBgWidth = 327
    let gridBgHeight = 100

    if (gridBgWidth / gridBgHeight > gameContainerWidth / gameContainerHeight) {
        scale = gameContainerWidth / gridBgWidth
    } else {
        scale = gameContainerHeight / gridBgHeight
    }

    if (operation === 'double' || operation === 'half' || operation === 'more' || operation === 'less') {
        let label1 = operation === 'double' || operation === 'half' ? 'double' : secondValue + ' more'
        let label2 = operation === 'double' || operation === 'half' ? 'half' : secondValue + ' less'

        return (
            <svg
                height={gameContainerHeight}
                width={gameContainerWidth}

            >
                <g transform={`translate(${(gameContainerWidth - gridBgWidth * scale) / 2}, ${(gameContainerHeight - gridBgHeight * scale) / 2}), scale(${scale})`}>

                    <image
                        width={gridBgWidth}
                        height={gridBgHeight}
                        xlinkHref={images.svg['two-directional-boxes']}

                    />
                    <text
                        fill="#fff"
                        fontSize={18.632}
                        fontWeight="regular"
                        dominantBaseline="middle"
                        x={gridBgWidth / 2}
                        y={10}
                        textAnchor="middle"
                    >{label1}</text>
                    <text
                        fill="#fff"
                        fontSize={18.632}
                        fontWeight="regular"
                        dominantBaseline="middle"
                        x={gridBgWidth / 2}
                        y={83}
                        textAnchor="middle"
                    >{label2}</text>

                    <text
                        fill="#fff"
                        fontSize={42.716}
                        fontWeight="regular"
                        dominantBaseline="middle"
                        x={50}
                        y={50}
                        textAnchor="middle"
                    >{operation === 'double' || operation === 'more' ? firstValue : answer}</text>

                    <text
                        fill="#fff"
                        fontSize={42.716}
                        fontWeight="regular"
                        dominantBaseline="middle"
                        x={gridBgWidth - 48}
                        y={50}
                        textAnchor="middle"
                    >{operation === 'double' || operation === 'more' ? answer : firstValue}</text>
                </g>
            </svg>
        )
    } else {
        let label1 = ''
        let label2 = ''
        let value1 = +answerNumber === 1 ? answer : previousAnswer ? previousAnswer : '?'
        let value2 = +answerNumber === 1 ? '?' : answer
        let colour1 = +answerNumber === 1 ? 'red' : 'black'
        let colour2 = +answerNumber === 1 ? 'black' : 'red'
        switch (operation) {
            case 'more/less':
                label1 = secondValue + ' less'
                label2 = secondValue + ' more'
                break
            case 'double/half':
                label1 = 'half'
                label2 = 'double'
                break
            case 'odd':
                label1 = 'previous odd number'
                label2 = 'next odd number'
                break
            case 'even':
                label1 = 'prev even number'
                label2 = 'next even number'
                break
            case 'mlpten':
                label1 = 'prev multiple of 10'
                label2 = 'next multiple of 10'
                break
        }

        let labels = operation === 'more/less' || operation === 'double/half' ? (
            <g>
                <text
                    fill="#fff"
                    fontSize={18.632}
                    fontWeight="regular"
                    dominantBaseline="middle"
                    x={50}
                    y={110}
                    textAnchor="middle"
                >{label1}</text>
                <text
                    fill="#fff"
                    fontSize={18.632}
                    fontWeight="regular"
                    dominantBaseline="middle"
                    x={gridBgWidth - 48}
                    y={110}
                    textAnchor="middle"
                >{label2}</text>
            </g>
        ) : (
                <g>
                    <text
                        fill="#fff"
                        fontSize={18.632}
                        fontWeight="regular"
                        dominantBaseline="middle"
                        x={0}
                        y={110}
                        textAnchor="start"
                    >{label1}</text>
                    <text
                        fill="#fff"
                        fontSize={18.632}
                        fontWeight="regular"
                        dominantBaseline="middle"
                        x={gridBgWidth}
                        y={110}
                        textAnchor="end"
                    >{label2}</text>
                </g>
            )
        return (
            <svg
                height={gameContainerHeight}
                width={gameContainerWidth}

            >
                <g transform={`translate(${(gameContainerWidth - gridBgWidth * scale) / 2}, ${(gameContainerHeight - gridBgHeight * scale) / 2}), scale(${scale})`}>

                    <image
                        width={gridBgWidth}
                        height={gridBgHeight}
                        xlinkHref={images.svg['two-directional-boxes-2']}

                    />
                    {labels}
                    <text
                        fill="#fff"
                        fontSize={42.716}
                        fontWeight="regular"
                        dominantBaseline="middle"
                        x={gridBgWidth / 2}
                        y={50}
                        textAnchor="middle"
                    >{firstValue}</text>
                    <text
                        fill="#fff"
                        fontSize={42.716}
                        fontWeight="regular"
                        dominantBaseline="middle"
                        x={50}
                        y={50}
                        textAnchor="middle"
                    >{value1}</text>

                    <text
                        fill="#fff"
                        fontSize={42.716}
                        fontWeight="regular"
                        dominantBaseline="middle"
                        x={gridBgWidth - 48}
                        y={50}
                        textAnchor="middle"
                    >{value2}</text>
                </g>
            </svg>
        )
    }
}

export default {
    getLevelLayout,
}




// WEBPACK FOOTER //
// ./src/components/game/levels/utils/biDirectionalBoxes.utils.js